
import React, { memo } from "react";

import { Form,Input } from "antd";

import {
  WrapInput
} from '../input-cpn/style'
export default memo(function SelectInputCpn(props) {
  const {title,fId } = props.info;
  const {rules} =props;
  return (
    <WrapInput>
      <Form.Item
        name={'fId'+fId}
        label={title}
        rules={rules}>
        <Input.TextArea />
      </Form.Item>
    </WrapInput>
  );
});
